import Repository from "@/repository";

const defaultCounterpartie = {
  name: "",
  inn: "",
  city: "",
  region: "",
  classification: "",
  product: "",
  counterparty_information: [],
  counterparty_contacts: [],
  legal_address: "",
  actual_address: "",
  phone_number: "",
  additional_phone_number: "",
  email: "",
  web_site: "",
  note: "",
  requisites: null
}

export default {
  state: {
    counterparties: [],
    counterpartie: JSON.parse(JSON.stringify(defaultCounterpartie)),
    totalPages: 1,
    thisPage: 1,
    cities: [],
    regions: []
  },
  actions: {
    async getCounterparties({ commit }, params) {
      const data = {
        product: params.product,
        city: params.city,
        region: params.region,
        classification: params.classification,
        name: params.name,
        inn: params.inn,
        size: 20
      };
      if (!params.isNotLoad) {
        commit("setIsLoader", true);
      }

      const { value, error } = await Repository.CounterpartiesActions.get(data)
      if (!error) {
        commit("setCounterparties", value.data)
        commit("setTotalPages", value.total_pages)
        commit("setThisPage", value.page)
        commit("setCities", value.cities)
        commit("setRegions", value.regions)
      }
      commit("setIsLoader", false);
    },
    async getCounterpartie({ commit }, slug) {
      commit("setIsLoader", true);
      const { value, error } = await Repository.CounterpartiesActions.getOne(slug)
      if (!error) {
        commit("setCounterpartie", value)
        value.requisites.forEach(i => commit("setFiles", i))
      }
      commit("setIsLoader", false);
    },
    async createCounterpartie({ commit, state }) {
      commit("setIsLoader", true);
      const { value, error } = await Repository.CounterpartiesActions.create(state.counterpartie)
      if (error) {
        commit("setErrors", error)
        commit("setIsLoader", false);
        return false
      }
      state.counterpartie.slug = value.slug
      await Repository.CounterpartiesActions.update(state.counterpartie)
      commit("resetCounterpartie")
      commit("setFiles", null);
      commit("setIsLoader", false);
      return true
    },
    async updateCounterpartie({ commit, state }) {
      commit("setIsLoader", true);
      const { error } = await Repository.CounterpartiesActions.update(state.counterpartie)
      if (error) {
        commit("setErrors", error)
        commit("setIsLoader", false);
        return false
      }
      commit("setIsLoader", false);
      return true
    },
    async deleteCounterpartie({ commit }, slug) {
      commit("setIsLoader", true);
      const { value, error } = await Repository.CounterpartiesActions.delete(slug)
      commit("setIsLoader", false);
    },
  },
  mutations: {
    setCounterpartiesField(state, { field, value }) {
      if (field.split(".").length > 1) {
        if (
          !(field.split(".")[0] in state.counterpartie) ||
          state.counterpartie[field.split(".")[0]] === null
        ) {
          state.counterpartie[field.split(".")[0]] = {};
        }
        state.counterpartie[field.split(".")[0]][field.split(".")[1]] = value;
      } else {
        state.counterpartie[field] = value
      }
    },
    setCounterparties(state, value) {
      state.counterparties = value
    },
    setCities(state, value) {
      state.cities = value
    },
    setRegions(state, value) {
      state.regions = value
    },
    setCounterpartie(state, value) {
      state.counterpartie = value
    },
    resetCounterpartie(state) {
      state.counterpartie = JSON.parse(JSON.stringify(defaultCounterpartie))
    },
    setTotalPages(state, value) {
      state.totalPages = value
    },
    setThisPage(state, value) {
      state.thisPage = value
    },
    deleteFileFromCounterpartie(state, id) {
      let index = ""
      state.counterparties.forEach((i, idx) => {
        i.requisites.forEach(j => {
          if (j.id === id) {
            index = idx
          }
        })
      })
      const counterpartie = state.counterparties[index]
      counterpartie.requisites = counterpartie.requisites.filter(i => i.id !== id)
      state.counterparties.splice(index, 1, counterpartie);
    },
  },
};
